module.exports = __webpack_public_path__ + "images/emoji/tram.02087328445bf73795d0.png";